module.exports = __webpack_public_path__ + "img/zbtitle.66fb8b3c.png";